import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Preloader from "../components/Preloader";
import MagnetCursor from "../components/MagnetCursor";
import ScrollToTop from "../components/ScrollToTop";

const SECTORS_API = "https://backenddev.aaerlaw.com/api/user/paraclearth_sectors";

function SectorDetails() {
  const location = useLocation();
  const id = new URLSearchParams(location.search).get("id");

  const [sector, setSector] = useState(null);
  const [allSectors, setAllSectors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    if (preloader) preloader.style.display = "none";
  }, []);

  useEffect(() => {
    if (!id) { setNotFound(true); setLoading(false); return; }

    Promise.all([
      fetch(`${SECTORS_API}/${id}`).then((r) => {
        if (!r.ok) throw new Error("not found");
        return r.json();
      }),
      fetch(`${SECTORS_API}?page=1&limit=50`).then((r) => r.json()),
    ])
      .then(([sec, list]) => {
        setSector(sec);
        if (Array.isArray(list?.data)) setAllSectors(list.data);
      })
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div>
        <Preloader />
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "60vh" }}
        >
          <div className="spinner-border text-secondary" role="status">
            <span className="visually-hidden">Loading&hellip;</span>
          </div>
        </div>
      </div>
    );
  }

  if (notFound || !sector) {
    return (
      <div>
        <Preloader />
        <div className="text-center py-5">
          <p>Sector not found.</p>
          <Link to="/sectors" className="btn btn-primary">
            View All Sectors
          </Link>
        </div>
        <ScrollToTop />
        <MagnetCursor />
      </div>
    );
  }

  return (
    <div>
      {/* Preloader */}
      <Preloader />

      {/* Breadcrumb Section */}
      <div
        className="breadcrumb-section breadcrumb-compact bg-img jarallax"
        data-jarallax=""
        data-speed="0.6"
        style={{ backgroundImage: "url('assets/img/bg-img/73.jpg')" }}
      >
        <div className="divider"></div>
        <div className="container">
          <div className="breadcrumb-content">
            <h2
              className="wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="700ms"
            >
              {sector.title}
            </h2>
            <ul
              className="list-unstyled wow fadeInUp"
              data-wow-duration="1000ms"
              data-wow-delay="1000ms"
            >
              <li>
                <Link className="magnet-link" to="/">
                  Home
                </Link>
              </li>
              <li>
                <Link className="magnet-link" to="/sectors">
                  Sectors
                </Link>
              </li>
              <li>{sector.title}</li>
            </ul>
          </div>
        </div>
        <div className="divider"></div>
      </div>

      {/* Sector Detail */}
      <div className="service-details-section bg-white">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-5">
            {/* Main Content */}
            <div className="col-12 col-lg-8">
              <div className="service-details-content">
                <div className="h2 mb-4">{sector.title}</div>
                {sector.description ? (
                  <div dangerouslySetInnerHTML={{ __html: sector.description }} />
                ) : (
                  <p>No details available for this sector yet.</p>
                )}
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-12 col-lg-4">
              <div className="d-flex flex-column gap-5">
                {allSectors.length > 0 && (
                  <div className="service-widget">
                    <div className="h4 fw-semibold mb-4">All Sectors</div>
                    <ul className="service-list">
                      {allSectors.map((s) => (
                        <li key={s.id}>
                          <Link
                            to={`/sectordetails?id=${s.id}`}
                            style={
                              String(s.id) === String(id)
                                ? { fontWeight: 700 }
                                : {}
                            }
                          >
                            {s.title}
                            <i className="ti ti-arrow-right"></i>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Helpline Card */}
                <div
                  className="helpline-card bg-img"
                  style={{ backgroundImage: "url('assets/img/bg-img/75.jpg')" }}
                >
                  <div className="h3 mb-2 fw-semibold text-white">
                    How Can We Help?
                  </div>
                  <p className="mb-4 text-white">
                    Our team is ready to assist you. Get in touch today.
                  </p>
                  <Link to="/bookconsultation" className="btn btn-primary">
                    <span>
                      Book Consultation{" "}
                      <i className="ti ti-arrow-up-right"></i>
                    </span>
                    <span>
                      Book Consultation{" "}
                      <i className="ti ti-arrow-up-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </div>

      {/* Scroll To Top */}
      <ScrollToTop />
      {/* Magnet Cursor */}
      <MagnetCursor />
    </div>
  );
}

export default SectorDetails;
